var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c(
      "div",
      {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: !_vm.loading || _vm.showContent,
            expression: "!loading || showContent"
          }
        ]
      },
      [_vm._t("default")],
      2
    ),
    _vm._v(" "),
    _c(
      "div",
      {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: _vm.loading,
            expression: "loading"
          }
        ],
        class: { fixed: _vm.showContent }
      },
      [
        _vm._t("label"),
        _vm._v(" "),
        _c("ring-loader", { attrs: { size: _vm.size, loading: _vm.loading } })
      ],
      2
    )
  ])
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-6875d85a", { render: render, staticRenderFns: staticRenderFns })
  }
}